import { AuthUserType } from "."
import { JWTAuthData, makeJWTAuthData } from "./types"

export const extractData = (jwt: string): JWTAuthData => {
  const payload = jwt.split(`.`)[1]
  const cleaned = payload.replace(/-/g, `+`).replace(/_/g, `/`)
  const parsed = JSON.parse(window.atob(cleaned))
  const claim = parsed[`https://platform.flock.com/user`]

  if (claim !== undefined) {
    return makeJWTAuthData({
      id: claim.id,
      expiresAt: parsed.exp,
      type: makeModernAuthUserType(claim.kind),
      ownerId: claim.ownerId ?? null,
    })
  }

  return makeJWTAuthData({
    id: parsed.sub,
    expiresAt: parsed.exp,
    type: makeAuthUserType(parsed.typ),
    ownerId: parsed.oid ?? null,
  })
}

export const isDataValid = (data: JWTAuthData): boolean => data.expiresAt * 1000 > Date.now()

function makeAuthUserType(type: string): AuthUserType {
  switch (type) {
    case `introducer`:
      return `distributor`
    case `broker`:
      return `admin`
    case `customer`:
      return `customer`
    case `claims_admin`:
      return `claims_admin`
    case `carrier`:
      return `carrier`
    default:
      return `customer`
  }
}

function makeModernAuthUserType(type: string): AuthUserType {
  switch (type) {
    case `broker`:
      return `distributor`
    case `flocker`:
      return `admin`
    case `customer`:
      return `customer`
    case `claims_admin`:
      return `claims_admin`
    case `carrier`:
      return `carrier`
    default:
      return `customer`
  }
}
